import down from '@/assets/svg/down.svg';
import { Language } from '@/i18n/language';
import { usePairs } from '@/store/pairs';
import clsx from 'clsx';
import { motion } from 'motion/react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Link } from 'react-router';
import { useShallow } from 'zustand/shallow';
import { PriceChange } from '../chart/price';
import NewBadgeAnimated from '../NewBadgeAnimated';
import { FormValue, ModeType } from './type';

export const MODE_KEY = '@defuture/mode';
const data = [
    { title: 'Lite', value: 'LITE' },
    { title: 'Pro', value: 'PRO' },
];

export function Mode() {
    const { control, setValue, reset } = useFormContext<FormValue>();
    const [activeTab, pairIndex] = useWatch({
        control,
        name: ['mode', 'pairIndex'],
    });

    const pairs = usePairs(useShallow((state) => state.data));
    const pair = pairs.find((item) => item.pairIndex === Number(pairIndex));

    const [first, last] = !pair
        ? ['', '']
        : [pair.symbol.split('USD')[0], 'USD'];
    return (
        <div>
            <div className="flex items-center justify-between mb-2.5">
                <Link to={'/market'} className="flex items-center gap-1">
                    <div className="w-5 h-5 rounded-full">
                        <img src={pair?.imageUrl ?? ''} alt="Symbol" />
                    </div>

                    <p className="text-lg text-white">
                        {first} <span className="opacity-30">/ {last}</span>
                    </p>

                    <img
                        src={down}
                        alt="down"
                        width={16}
                        height={16}
                        loading="lazy"
                    />

                    {pair?.tag && <NewBadgeAnimated tag={pair.tag} />}
                </Link>

                <div className="flex items-center gap-4">
                    <div className="flex items-center justify-center h-[32px] border border-[#1C1C1C] rounded-[10px] px-1">
                        {data.map((item, idx) => {
                            return (
                                <button
                                    type="button"
                                    onClick={() => {
                                        localStorage.setItem(
                                            MODE_KEY,
                                            item.value
                                        );
                                        reset();
                                        setValue(
                                            'mode',
                                            item.value as ModeType
                                        );
                                    }}
                                    key={idx}
                                    className={clsx(
                                        'relative h-6 flex items-center justify-center text-sm px-2 text-white opacity-20 transition-all',
                                        {
                                            'opacity-100':
                                                item.value === activeTab,
                                        }
                                    )}
                                >
                                    {item.value === activeTab ? (
                                        <motion.div
                                            layoutId="underline1"
                                            id="underline1"
                                            className="absolute inset-0 rounded-[6px] bg-[#1C1C1C] -z-10"
                                        />
                                    ) : null}

                                    <span>{item.title}</span>
                                </button>
                            );
                        })}
                    </div>
                    <Language />
                </div>
            </div>
            <div className="my-4 flex items-center justify-between flex-row">
                <PriceChange pairIndex={pairIndex} pairInfo={pair} />
                {/* <ClaimFreeWld /> */}
            </div>
        </div>
    );
}
